import { render } from "./RemoveDeviceFromGroupDialog.vue?vue&type=template&id=90f5b0fa"
import script from "./RemoveDeviceFromGroupDialog.vue?vue&type=script&lang=js"
export * from "./RemoveDeviceFromGroupDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__